import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.issues');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-issues',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.issues/view.scss */
/* src/app/page.admin.issues/view.scss: no such file or directory */`],
})
export class PageAdminIssuesComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public item: any;

    public async ngDoCheck() {
        this.item = WizRoute.segment.item;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        // this.title.setTitle("기관현황 - MY KREONET");
    }
}

export default PageAdminIssuesComponent;